var PresentationTokenFactory = {};

export { PresentationTokenFactory as __exports };
//# sourceMappingURL=_virtual-PresentationTokenFactory.js.map
